module.exports = __webpack_public_path__ + "img/xiaomi-2.4e6aaceb.webp";